export * from './associado-edit.component';
export * from './associado-browse.component';